import { render, staticRenderFns } from "./Fixed.token.vue?vue&type=template&id=34e921f2&"
import script from "./Fixed.token.vue?vue&type=script&lang=ts&"
export * from "./Fixed.token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports